// extracted by mini-css-extract-plugin
export default {"panel":"CollapsiblePanel_panel__6DSMS","open":"CollapsiblePanel_open__g4R-E","button":"CollapsiblePanel_button__mUXEK"};